








































import { Component, Vue, Prop } from "vue-property-decorator";
import { Asset } from "@foxone/api/src/models/wallet/mixin";
import { State } from "vuex-class";

@Component
class AssetItem extends Vue {
  @Prop() asset!: Asset;

  @State(state => state.wallet.mixin.hidden) hidden;

  @State(state => state.app.settings.hideTinyAssets) hideTinyAssets;

  get logo() {
    return this.asset.icon_url;
  }

  get chainLogo() {
    return this.$common.utils.helper.getChainLogo(this, this.asset);
  }

  get hideAsset() {
    const totalUSDT = Number(this.asset.balance) * Number(this.asset.price_usd);
    return this.hideTinyAssets && totalUSDT < 0.0001;
  }

  get price() {
    const price = this.$common.utils.currency.fiat(this, {
      value: this.asset.price_usd,
      from: "USD"
    });
    return `${price}`;
  }

  get changeAmount() {
    const { change_usd, price_usd, balance } = this.asset;
    const changeAmount = Math.abs(+change_usd) * +price_usd * +balance;
    const totalLegal = this.$common.utils.currency.fiat(this, {
      value: changeAmount,
      from: "USD"
    });
    return `≈${totalLegal}`;
  }

  get totalLegal() {
    const currency = this.$common.utils.currency.getCurrentCurrency(
      this.$store
    );
    const totalUSDT = Number(this.asset.balance) * Number(this.asset.price_usd);
    const totalLegal = this.$common.utils.currency.fiat(this, {
      value: totalUSDT,
      from: "USD"
    });
    return this.hidden ? `≈${currency}****` : `≈${totalLegal}`;
  }

  get changePercent() {
    return this.$common.utils.number.toPercent(this.asset.change_usd, true);
  }

  get color() {
    return this.$common.utils.helper.getColor(
      this.$store,
      this.asset.change_usd
    );
  }

  handleAssetClick() {
    this.$emit("detail", this.asset.asset_id);
  }
}
export default AssetItem;
